var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMore = function SvgIconMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-more"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00015 11.7692C8.8923 11.7692 9.61553 12.4925 9.61553 13.3846C9.61553 14.2768 8.8923 15 8.00015 15C7.108 15 6.38477 14.2768 6.38477 13.3846C6.38477 12.4925 7.108 11.7692 8.00015 11.7692ZM8.00024 6.38461C8.8924 6.38461 9.61563 7.10785 9.61563 8C9.61563 8.89215 8.8924 9.61538 8.00024 9.61538C7.10809 9.61538 6.38486 8.89215 6.38486 8C6.38486 7.10785 7.10809 6.38461 8.00024 6.38461ZM9.61563 2.61538C9.61563 1.72323 8.8924 1 8.00024 1C7.10809 1 6.38486 1.72323 6.38486 2.61539C6.38486 3.50754 7.10809 4.23077 8.00024 4.23077C8.8924 4.23077 9.61563 3.50754 9.61563 2.61538Z",
    fill: "#31333E"
  }))));
};
export default SvgIconMore;